module.exports = __webpack_public_path__ + "static/media/GA-2100FF-8AER_OR18_caseback.66d47ac2.jpg";